/* DTB — custom elements dùng chung cho các section tự viết. Không phụ thuộc thư viện ngoài. */

/** Rail cuộn ngang với 2 nút [data-dir="prev"|"next"]. Track là phần tử .dtb-rail__track. */
class DtbRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.dtb-rail__track');
    if (!this.track) return;
    this.querySelectorAll('[data-dir]').forEach((btn) => {
      btn.addEventListener('click', () => this.scrollByDir(btn.dataset.dir));
    });
  }
  scrollByDir(dir) {
    const first = this.track.firstElementChild;
    const step = first ? first.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: dir === 'prev' ? -step * 2 : step * 2, behavior: 'smooth' });
  }
  /** Cuộn tới item thứ index và đánh dấu is-active */
  focusItem(index) {
    const items = [...this.track.children];
    items.forEach((el, i) => el.classList.toggle('is-active', i === index));
    const el = items[index];
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
}
customElements.define('dtb-rail', DtbRail);

/** Ảnh có chấm hotspot [data-index]; click → rail (attribute for="id") cuộn tới card tương ứng. */
class DtbHotspots extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const dot = e.target.closest('[data-index]');
      if (!dot) return;
      e.preventDefault();
      const index = Number(dot.dataset.index);
      this.querySelectorAll('[data-index]').forEach((d) => d.classList.toggle('is-active', d === dot));
      const rail = document.getElementById(this.getAttribute('for') || '');
      if (rail && typeof rail.focusItem === 'function') rail.focusItem(index);
    });
  }
}
customElements.define('dtb-hotspots', DtbHotspots);

/** Popup chào mừng: mở sau `delay` giây nếu chưa từng đóng; [data-close] đóng; [data-copy] copy mã. */
class DtbPopup extends HTMLElement {
  connectedCallback() {
    if (window.Shopify && window.Shopify.designMode) return; // không tự bật trong Theme Editor
    const key = 'dtbPopupDismissed';
    try { if (localStorage.getItem(key)) return; } catch (e) { /* localStorage bị chặn */ }
    const delay = Number(this.getAttribute('delay') || 3) * 1000;
    this.timer = setTimeout(() => this.classList.add('is-open'), delay);
    this.querySelectorAll('[data-close]').forEach((b) =>
      b.addEventListener('click', () => {
        this.classList.remove('is-open');
        try { localStorage.setItem(key, '1'); } catch (e) { /* bỏ qua */ }
      })
    );
    const copy = this.querySelector('[data-copy]');
    if (copy) {
      copy.addEventListener('click', async () => {
        const code = copy.dataset.copy || '';
        try { await navigator.clipboard.writeText(code); copy.textContent = 'Copied!'; } catch (e) { copy.textContent = code; }
      });
    }
  }
  disconnectedCallback() { clearTimeout(this.timer); }
}
customElements.define('dtb-popup', DtbPopup);

/** Hero slideshow: [data-slide] các slide, [data-dir] mũi tên, [data-dot] chấm; data-autoplay/data-interval. */
class DtbSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.i = 0;
    this.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', () => this.go(this.i + (b.dataset.dir === 'prev' ? -1 : 1))));
    this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.dot))));
    if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
      const ms = (Number(this.dataset.interval) || 5) * 1000;
      this.timer = setInterval(() => this.go(this.i + 1), ms);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
    }
    // Trong Theme Editor: chọn block slide -> hiện đúng slide đó
    this.onSelect = (e) => { const k = this.slides.findIndex((s) => s.contains(e.target)); if (k >= 0) this.go(k); };
    document.addEventListener('shopify:block:select', this.onSelect);
  }
  go(n) {
    if (!this.slides.length) return;
    this.i = (n + this.slides.length) % this.slides.length;
    this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.i));
    this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.i));
  }
  disconnectedCallback() { clearInterval(this.timer); document.removeEventListener('shopify:block:select', this.onSelect); }
}
customElements.define('dtb-slideshow', DtbSlideshow);


/** Dòng "Order by [date] for delivery before [holiday] · [days] days left" — dùng ở block dtb-order-by (trang sp) và cart-summary. */
class DtbOrderBy extends HTMLElement {
    connectedCallback() {
      const transit = +this.dataset.transit || 13; const now = new Date(); const y = now.getFullYear();
      const list = this.dataset.holidays.split(',').map((s) => s.trim()).filter(Boolean).map((s) => { const [md, ...rest] = s.split(' '); const [m, d] = md.split('-').map(Number); let date = new Date(y, m - 1, d); if (date < now) date = new Date(y + 1, m - 1, d); return { date, name: rest.join(' ') }; }).sort((a, b) => a.date - b.date);
      const next = list.find((h) => (h.date - now) / 864e5 >= transit + 1); if (!next) { this.hidden = true; return; }
      const orderBy = new Date(next.date.getTime() - transit * 864e5); const days = Math.ceil((orderBy - now) / 864e5);
      const fmt = (dt) => dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      this.textContent = this.dataset.template.replace('[date]', fmt(orderBy)).replace('[holiday]', next.name).replace('[days]', days);
    }
  }
if (!customElements.get('dtb-order-by')) customElements.define('dtb-order-by', DtbOrderBy);

/** "Choose your offer": chọn thẻ → set ô số lượng của form; giá tính theo variant đang chọn (input[name=id]). */
class DtbBundles extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.dataset.variants || '[]');
    const fmt = this.dataset.moneyFormat || '${{amount}}';
    const re = new RegExp('\\{\\{\\s*(amount[a-z_]*)\\s*\\}\\}');
    this.money = (c) => { const m = fmt.match(re); const key = m ? m[1] : 'amount'; const v = c / 100; let s; if (key === 'amount_no_decimals') s = Math.round(v).toLocaleString('en-US'); else if (key === 'amount_no_decimals_with_comma_separator') s = Math.round(v).toLocaleString('de-DE'); else if (key === 'amount_with_comma_separator') s = v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); else s = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); return fmt.replace(/<[^>]+>/g, '').replace(re, s); };
    this.items = [...this.querySelectorAll('.dtb-bund__it')];
    this.items.forEach((it) => it.querySelector('input').addEventListener('change', () => this.select(it)));
    this.render(); this.timer = setInterval(() => this.render(), 700);
  }
  disconnectedCallback() { clearInterval(this.timer); }
  variant() { const form = this.closest('form') || document; const inp = form.querySelector('input[name="id"]') || document.querySelector('input[name="id"]'); const id = inp ? +inp.value : 0; return this.variants.find((v) => v.id === id) || this.variants[0]; }
  render() {
    const v = this.variant(); if (!v || v.price === this.lastPrice) return; this.lastPrice = v.price;
    this.items.forEach((it) => { const q = +it.dataset.qty, pct = +it.dataset.pct; const base = v.price * q; const now = Math.round(base * (1 - pct / 100)); it.querySelector('[data-now]').textContent = this.money(now); const was = it.querySelector('[data-was]'); was.textContent = pct > 0 || (v.compare_at_price && v.compare_at_price > v.price) ? this.money(Math.max(base, (v.compare_at_price || 0) * q)) : ''; });
  }
  select(it) {
    this.items.forEach((x) => x.classList.toggle('is-active', x === it));
    const qty = +it.dataset.qty; const inp = document.querySelector('.product-details input[name="quantity"], product-form-component input[name="quantity"], input[name="quantity"]');
    if (inp) { inp.value = qty; inp.dispatchEvent(new Event('input', { bubbles: true })); inp.dispatchEvent(new Event('change', { bubbles: true })); }
    document.dispatchEvent(new CustomEvent('dtb:bundle', { detail: { qty } }));
  }
}
if (!customElements.get('dtb-bundles')) customElements.define('dtb-bundles', DtbBundles);

/** Urgency: số người xem ngẫu nhiên (đổi mỗi 8–20s), đếm ngược tới nửa đêm. */
class DtbUrgency extends HTMLElement {
  connectedCallback() {
    const min = +this.dataset.min || 20, max = +this.dataset.max || 90; const t = this.querySelector('[data-viewers-text]'); const tpl = this.dataset.viewers || '[n] people are viewing this right now';
    let n = min + Math.floor(Math.random() * (max - min)); const show = () => { t.textContent = tpl.replace('[n]', n); };
    show(); this.vt = setInterval(() => { n = Math.min(max, Math.max(min, n + Math.floor(Math.random() * 7) - 3)); show(); }, 8000 + Math.random() * 12000);
    // Đếm ngược riêng cho từng khách: bắt đầu khi họ vào trang, giữ nguyên khi chuyển trang trong cùng phiên.
    const clock = this.querySelector('[data-clock]');
    if (clock) {
      const mins = +this.dataset.minutes || 60;
      const key = 'dtb:urg:' + (this.dataset.key || location.pathname);
      let end = 0;
      try { end = +sessionStorage.getItem(key) || 0; } catch (e) { end = 0; }
      if (!end || end - Date.now() > mins * 60000 || end <= Date.now()) {
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      const tick = () => {
        let s = Math.max(0, Math.round((end - Date.now()) / 1000));
        const h = String(Math.floor(s / 3600)).padStart(2, '0');
        s %= 3600;
        clock.textContent = `${h}:${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
        if (s <= 0 && end <= Date.now()) clearInterval(this.ct);
      };
      tick();
      this.ct = setInterval(tick, 1000);
    }
  }
  disconnectedCallback() { clearInterval(this.vt); clearInterval(this.ct); }
}
if (!customElements.get('dtb-urgency')) customElements.define('dtb-urgency', DtbUrgency);

/** Danh sách review: nút "Show more" hiện thêm N review mỗi lần. */
class DtbReviewsList extends HTMLElement {
  connectedCallback() {
    const btn = this.parentElement.querySelector('[data-more]'); if (!btn) return; const step = +this.dataset.step || 6;
    btn.addEventListener('click', () => { const hidden = [...this.querySelectorAll('.dtb-rv__it[hidden]')]; hidden.slice(0, step).forEach((el) => (el.hidden = false)); if (hidden.length <= step) btn.hidden = true; });
    const root = this.closest('.dtb-rv') || document;
    root.querySelectorAll('[data-go]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = this.querySelector('#' + thumb.dataset.go);
        if (!target) return;
        this.querySelectorAll('.dtb-rv__it[hidden]').forEach((el) => (el.hidden = false));
        btn.hidden = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.classList.add('dtb-rv__it--flash');
        setTimeout(() => target.classList.remove('dtb-rv__it--flash'), 1600);
      });
    });
  }
}
if (!customElements.get('dtb-reviews-list')) customElements.define('dtb-reviews-list', DtbReviewsList);

class DtbMore extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-more]');
    if (!btn) return;
    const root = this.closest('.dtb-story2') || this;
    btn.addEventListener('click', () => {
      root.querySelectorAll('[data-extra]').forEach((el) => { el.hidden = false; });
      btn.remove();
    });
  }
}
if (!customElements.get('dtb-more')) customElements.define('dtb-more', DtbMore);
